export interface Book {
  id: string;
  title: string;
  author: string;
  tags: string[];
  score: number;
  readers: number;
  wordCount: string;
  status: string;
  summary: string;
  cover: string;
  rank?: number;
  trend: string;
}

export const hotRanking: Book[] = [
  {
    id: 'b01',
    title: '星海彼端的守夜人',
    author: '陆行舟',
    tags: ['科幻', '群像', '硬核'],
    score: 9.4,
    readers: 128600,
    wordCount: '218万字',
    status: '连载中',
    summary: '一艘穿越星云的远航飞船，在信号断绝的深空里，一位守夜人独自守护着一船沉睡的乘客与一段被遗忘的真相。',
    cover: 'https://readdy.ai/api/search-image?query=scifi%20novel%20book%20cover%20illustration%20of%20a%20lone%20lighthouse%20keeper%20on%20a%20drifting%20spaceship%2C%20deep%20ink%20blue%20night%20sky%20with%20starfield%2C%20warm%20lantern%20glow%2C%20minimalist%20editorial%20cover%20art%2C%20subtle%20texture&width=600&height=800&seq=yuzhai-b01&orientation=portrait',
    trend: 'up',
  },
  {
    id: 'b02',
    title: '妖怪食堂的招财猫',
    author: '桃桃乌龙',
    tags: ['奇幻', '治愈', '日常'],
    score: 9.2,
    readers: 110200,
    wordCount: '86万字',
    status: '已完结',
    summary: '深夜才营业的妖怪食堂，只有一只会算账的招财猫在等客人。每个故事都藏着一道菜的温度，和一段放不下的执念。',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20fantasy%20novel%20book%20cover%20illustration%20of%20a%20lucky%20cat%20chef%20in%20a%20tiny%20night%20restaurant%2C%20warm%20lamp%20light%2C%20steaming%20food%2C%20whimsical%20gently%20colored%20art%2C%20minimalist%20cover&width=600&height=800&seq=yuzhai-b02&orientation=portrait',
    trend: 'up',
  },
  {
    id: 'b03',
    title: '剑冢·山河故人',
    author: '青崖白鹿',
    tags: ['武侠', '热血', '复仇'],
    score: 9.0,
    readers: 98400,
    wordCount: '342万字',
    status: '连载中',
    summary: '少年携一柄断剑出山，走过十三年江湖。恩怨、情义、家国，在剑冢之下层层揭开。刀光剑影里，尽是故人旧梦。',
    cover: 'https://readdy.ai/api/search-image?query=wuxia%20novel%20book%20cover%20illustration%20of%20a%20lone%20swordsman%20with%20broken%20sword%20before%20ancient%20tomb%20amid%20misty%20mountains%2C%20ink%20wash%20style%2C%20terracotta%20and%20charcoal%20palette%2C%20dramatic%20composition&width=600&height=800&seq=yuzhai-b03&orientation=portrait',
    trend: 'up',
  },
  {
    id: 'b04',
    title: '穿成反派后我摊牌了',
    author: '木有枝',
    tags: ['穿书', '轻松', '沙雕'],
    score: 8.8,
    readers: 156300,
    wordCount: '112万字',
    status: '已完结',
    summary: '穿成注定领盒饭的反派，主角却直接摊牌。不按剧本走的人生，意外收获了一群真心的「队友」和一段有趣的故事。',
    cover: 'https://readdy.ai/api/search-image?query=humorous%20fantasy%20webnovel%20book%20cover%20of%20a%20modern%20person%20in%20ancient%20costume%20giving%20a%20wink%2C%20playful%20bright%20illustration%2C%20warm%20cream%20background%2C%20minimalist%20cute%20style&width=600&height=800&seq=yuzhai-b04&orientation=portrait',
    trend: 'down',
  },
  {
    id: 'b05',
    title: '雾都侦探手记',
    author: '半盏清茶',
    tags: ['悬疑', '推理', '单元剧'],
    score: 9.1,
    readers: 87200,
    wordCount: '158万字',
    status: '连载中',
    summary: '常年雾气弥漫的旧城，一位不爱出门的侦探靠一封封信解开尘封旧案。线索藏在细节里，真相远比想象复杂。',
    cover: 'https://readdy.ai/api/search-image?query=mystery%20detective%20novel%20book%20cover%20illustration%20of%20a%20foggy%20old%20city%20street%20with%20a%20figure%20holding%20an%20umbrella%20and%20letters%2C%20noir%20moody%20tones%2C%20muted%20teal%20and%20ink%20palette%2C%20minimalist&width=600&height=800&seq=yuzhai-b05&orientation=portrait',
    trend: 'up',
  },
  {
    id: 'b06',
    title: '山海食堂本店',
    author: '苏鱼',
    tags: ['美食', '志怪', '单元'],
    score: 9.3,
    readers: 76100,
    wordCount: '96万字',
    status: '已完结',
    summary: '山神与海怪轮流开店的本店，菜单每日更新。人间烟火与山海传说交织，每一道菜都是一场奇遇。',
    cover: 'https://readdy.ai/api/search-image?query=chinese%20mythology%20food%20novel%20book%20cover%20illustration%20of%20a%20magical%20restaurant%20with%20mountain%20deity%20and%20sea%20monster%20chefs%2C%20warm%20terracotta%20and%20jade%20green%20tones%2C%20whimsical%20ink%20art&width=600&height=800&seq=yuzhai-b06&orientation=portrait',
    trend: 'flat',
  },
];

export const praiseRanking: Book[] = [
  {
    id: 'b07',
    title: '长夜将至',
    author: '南枝向暖',
    tags: ['末世', '生存', '群像'],
    score: 9.6,
    readers: 91300,
    wordCount: '286万字',
    status: '连载中',
    summary: '文明崩塌的第一个夜晚，有人选择逃离，有人选择坚守。末世之下，人性的微光比灾难本身更令人动容。',
    cover: 'https://readdy.ai/api/search-image?query=apocalyptic%20novel%20book%20cover%20illustration%20of%20a%20small%20campfire%20in%20a%20dark%20ruined%20city%2C%20single%20warm%20light%20source%2C%20somber%20yet%20hopeful%2C%20minimalist%20ink%20and%20amber%20palette&width=600&height=800&seq=yuzhai-b07&orientation=portrait',
    trend: 'up',
  },
  {
    id: 'b08',
    title: '纸上少年',
    author: '阿鲸',
    tags: ['青春', '治愈', '成长'],
    score: 9.5,
    readers: 58800,
    wordCount: '42万字',
    status: '已完结',
    summary: '一部关于告别与重来的青春随笔。在合上相册的那个夏天，少年终于学会了与自己和解。',
    cover: 'https://readdy.ai/api/search-image?query=coming%20of%20age%20youth%20novel%20book%20cover%20illustration%20of%20a%20notebook%20with%20doodles%20and%20a%20skateboard%20by%20a%20summer%20window%2C%20soft%20warm%20light%2C%20nostalgic%20minimalist%20art&width=600&height=800&seq=yuzhai-b08&orientation=portrait',
    trend: 'up',
  },
  {
    id: 'b09',
    title: '万神殿重建计划',
    author: '关山月',
    tags: ['神话', '基建', '脑洞'],
    score: 9.4,
    readers: 67400,
    wordCount: '174万字',
    status: '连载中',
    summary: '众神陨落之后，凡人捡起了他们的图纸。重建万神殿，也重建被遗忘的一切——包括神明们不愿提起的往事。',
    cover: 'https://readdy.ai/api/search-image?query=mythology%20civilization%20novel%20book%20cover%20illustration%20of%20ancient%20marble%20temple%20under%20construction%20with%20floating%20blueprints%2C%20golden%20light%2C%20epic%20minimalist%20concept%20art&width=600&height=800&seq=yuzhai-b09&orientation=portrait',
    trend: 'flat',
  },
  {
    id: 'b10',
    title: '小卖部与时光机',
    author: '白桃汽水',
    tags: ['日常', '怀旧', '温馨'],
    score: 9.3,
    readers: 51900,
    wordCount: '35万字',
    status: '已完结',
    summary: '巷子口的小卖部里有一台坏掉的时光机。每天放学后的孩子们，在这里交换着关于昨天和明天的秘密。',
    cover: 'https://readdy.ai/api/search-image?query=nostalgic%20slice%20of%20life%20novel%20book%20cover%20of%20a%20quaint%20corner%20store%20with%20old%20candies%20and%20a%20tiny%20time%20machine%2C%20warm%20sunlight%2C%20cozy%20retro%20minimalist%20art&width=600&height=800&seq=yuzhai-b10&orientation=portrait',
    trend: 'up',
  },
];

export const hotTopicRanking: Book[] = [
  {
    id: 'b11',
    title: '机甲高校的转学生',
    author: '陆沉舟',
    tags: ['机甲', '校园', '热血'],
    score: 8.9,
    readers: 132800,
    wordCount: '208万字',
    status: '连载中',
    summary: '机甲决斗是这所高校的唯一法则。转学生带来的，不只是驾校的传说，更是一段被封锁的旧日战史。',
    cover: 'https://readdy.ai/api/search-image?query=mecha%20academy%20novel%20book%20cover%20illustration%20of%20a%20student%20pilot%20in%20front%20of%20a%20mecha%20in%20a%20school%20courtyard%2C%20dynamic%20warm%20and%20teal%20tones%2C%20energetic%20minimalist%20art&width=600&height=800&seq=yuzhai-b11&orientation=portrait',
    trend: 'up',
  },
  {
    id: 'b12',
    title: '说好的末世呢',
    author: '橘络',
    tags: ['末世', '搞笑', '群像'],
    score: 8.7,
    readers: 145500,
    wordCount: '124万字',
    status: '连载中',
    summary: '末日预言响彻全球，结果只是一场乌龙。世界照常运转，只有一群倒霉蛋还在认真备战。笑点密集，眼泪也有。',
    cover: 'https://readdy.ai/api/search-image?query=comedy%20apocalypse%20novel%20book%20cover%20illustration%20of%20a%20group%20of%20people%20with%20weird%20survival%20gear%20in%20a%20normal%20sunny%20park%2C%20bright%20playful%20minimalist%20art&width=600&height=800&seq=yuzhai-b12&orientation=portrait',
    trend: 'down',
  },
  {
    id: 'b13',
    title: '纸上江湖编辑部',
    author: '长安客',
    tags: ['武侠', '职场', '反差'],
    score: 9.0,
    readers: 69700,
    wordCount: '91万字',
    status: '已完结',
    summary: '武林日报编辑部里，一群不会武功的编辑在催更各路大侠。江湖恩怨与职场日常，碰撞出意想不到的火花。',
    cover: 'https://readdy.ai/api/search-image?query=wuxia%20office%20novel%20book%20cover%20illustration%20of%20newspaper%20editors%20working%20at%20desks%20while%20martial%20arts%20masters%20fly%20outside%20window%2C%20playful%20ink%20style%2C%20warm%20tones&width=600&height=800&seq=yuzhai-b13&orientation=portrait',
    trend: 'up',
  },
];

export const newBookRanking: Book[] = [
  {
    id: 'b14',
    title: '雨后见南山',
    author: '木槿花开',
    tags: ['现代', '都市', '治愈'],
    score: 8.9,
    readers: 32600,
    wordCount: '28万字',
    status: '连载中',
    summary: '新作上线。一个从城市逃离到山村的年轻人，在雨后的南山脚下，遇见了生活本来的样子。',
    cover: 'https://readdy.ai/api/search-image?query=healing%20modern%20novel%20book%20cover%20illustration%20of%20a%20mountain%20village%20after%20rain%20with%20fog%20and%20a%20small%20house%2C%20fresh%20jade%20and%20cream%20tones%2C%20serene%20minimalist%20art&width=600&height=800&seq=yuzhai-b14&orientation=portrait',
    trend: 'up',
  },
  {
    id: 'b15',
    title: '星屑收集者',
    author: '北岛来信',
    tags: ['科幻', '单元剧', '温柔'],
    score: 9.0,
    readers: 21400,
    wordCount: '17万字',
    status: '连载中',
    summary: '新作首发。一位收集散落星屑的旅行者，为每颗星星修补记忆，也为每个路过的人缝补遗憾。',
    cover: 'https://readdy.ai/api/search-image?query=gentle%20sci%20fi%20novel%20book%20cover%20illustration%20of%20a%20traveller%20collecting%20glowing%20stardust%20in%20a%20jar%20under%20a%20night%20sky%2C%20soft%20warm%20glow%2C%20dreamy%20minimalist%20art&width=600&height=800&seq=yuzhai-b15&orientation=portrait',
    trend: 'up',
  },
  {
    id: 'b16',
    title: '云端食堂再营业',
    author: '苏鱼',
    tags: ['美食', '志怪', '单元'],
    score: 9.1,
    readers: 18200,
    wordCount: '21万字',
    status: '连载中',
    summary: '人气续作回归。这一次，食堂开到了云端，招待着来自天南海北、只为一餐而来的特殊客人。',
    cover: 'https://readdy.ai/api/search-image?query=cloud%20food%20restaurant%20novel%20book%20cover%20illustration%20of%20a%20restaurant%20floating%20above%20clouds%20with%20steaming%20dishes%2C%20warm%20golden%20and%20teal%20palette%2C%20whimsical%20minimalist%20art&width=600&height=800&seq=yuzhai-b16&orientation=portrait',
    trend: 'up',
  },
];

export const categories = [
  { name: '玄幻仙侠', count: 1280, icon: 'ri-sword-line', desc: '仙途侠影，快意恩仇' },
  { name: '科幻未来', count: 860, icon: 'ri-rocket-line', desc: '星辰大海，脑洞无边' },
  { name: '悬疑推理', count: 640, icon: 'ri-focus-3-line', desc: '迷雾重重，真相待揭' },
  { name: '奇幻志怪', count: 720, icon: 'ri-ghost-line', desc: '山海异闻，奇谭不断' },
  { name: '轻小说', count: 980, icon: 'ri-cup-line', desc: '轻松日常，元气满满' },
  { name: '都市现实', count: 540, icon: 'ri-building-line', desc: '烟火人间，冷暖自知' },
  { name: '青春校园', count: 420, icon: 'ri-graduation-cap-line', desc: '少年心事，纸短情长' },
  { name: '游戏竞技', count: 380, icon: 'ri-gamepad-line', desc: '电竞热血，巅峰对决' },
];

export const recommendations = [
  {
    id: 'r1',
    user: '夜航星',
    avatar: 'https://readdy.ai/api/search-image?query=flat%20minimalist%20avatar%20illustration%20of%20a%20sailor%20under%20a%20starry%20sky%2C%20warm%20amber%20and%20teal%20tones%2C%20clean%20vector%20style&width=200&height=200&seq=yuzhai-av1&orientation=squarish',
    book: '长夜将至',
    score: 9.7,
    tag: '读完震撼',
    text: '末世的题材看了很多，这一本把「人性微光」写到了骨子里。第 47 章的守夜人独白，我反复读了三遍，推荐给所有喜欢群像叙事的同好。',
  },
  {
    id: 'r2',
    user: '半勺糖',
    avatar: 'https://readdy.ai/api/search-image?query=flat%20minimalist%20avatar%20illustration%20of%20a%20smiling%20girl%20with%20a%20sugar%20bowl%2C%20soft%20warm%20colors%2C%20clean%20vector%20style&width=200&height=200&seq=yuzhai-av2&orientation=squarish',
    book: '妖怪食堂的招财猫',
    score: 9.3,
    tag: '治愈宝藏',
    text: '深夜读这本真的会被治愈到。每一道菜都有人情味，招财猫傲娇又温柔。是我最近强推的治愈系，睡前读物天花板。',
  },
  {
    id: 'r3',
    user: '剑气横秋',
    avatar: 'https://readdy.ai/api/search-image?query=flat%20minimalist%20avatar%20illustration%20of%20a%20swordsman%20with%20flying%20leaves%20in%20autumn%2C%20terracotta%20and%20ink%20tones%2C%20clean%20vector%20style&width=200&height=200&seq=yuzhai-av3&orientation=squarish',
    book: '剑冢·山河故人',
    score: 9.4,
    tag: '热血上头',
    text: '很久没看到这么纯正的武侠了。打戏干净利落，文戏情义千钧。断剑出山的设定很有记忆点，追更不亏。',
  },
  {
    id: 'r4',
    user: '星野结衣',
    avatar: 'https://readdy.ai/api/search-image?query=flat%20minimalist%20avatar%20illustration%20of%20a%20girl%20gazing%20at%20stars%2C%20warm%20and%20jade%20tones%2C%20clean%20vector%20style&width=200&height=200&seq=yuzhai-av4&orientation=squarish',
    book: '星屑收集者',
    score: 9.1,
    tag: '新作惊喜',
    text: '新作里最喜欢的一本！单元剧的温柔感很戳我，收集星屑修补遗憾的设定特别浪漫。已经按头安利给整个书友群了。',
  },
];

export const faqs = [
  {
    q: '「御宅书屋」的评分是怎么来的？',
    a: '御宅书屋的评分由站内读者真实提交的星级与短评汇总而成，并通过加权算法去除异常波动，力求客观呈现一部作品在读者心中的口碑。榜单每 24 小时自动更新一次。',
  },
  {
    q: '人气排行和口碑榜单有什么区别？',
    a: '人气排行主要综合阅读人数、收藏与追更数据，反映「大家都在看什么」；口碑榜单则侧重读者评分与好评率，反映「哪些作品值得补」。两者结合，能帮你快速找到对味的作品。',
  },
  {
    q: '我可以自己推荐作品、写书评吗？',
    a: '可以。注册成为会员后，你可以为作品打分、撰写短评、加入打卡与书单，还可以在「同好推荐」区发布自己的推荐语，和更多同好分享你的阅读体验。',
  },
  {
    q: '如何判断一部作品是否适合我？',
    a: '你可以在作品详情页查看题材标签、读者评分、短评与同好推荐。建议先读几条与你口味相近的同好书评，通常能最快判断这部作品对不对你的胃口。',
  },
  {
    q: '榜单多久更新一次？',
    a: '人气、口碑、热议与新书四类榜单均每日更新，新书榜每小时校准一次。更新后的榜单与数据会实时同步到网站各页面。',
  },
  {
    q: '遇到榜单数据异常或误报怎么办？',
    a: '我们设有严格的审核机制。若发现疑似刷分或恶意差评，可通过网站底部的联系方式向我们反馈，审核团队会在 48 小时内处理并修正数据。',
  },
];

export const stats = [
  { value: '12.8万', label: '活跃书友' },
  { value: '8600+', label: '在读书目' },
  { value: '54万+', label: '累计书评' },
  { value: '98%', label: '书友满意度' },
];

export const genres = [
  '玄幻仙侠', '科幻未来', '悬疑推理', '奇幻志怪',
  '轻小说', '都市现实', '青春校园', '游戏竞技',
];